<div>
  <!-- Table -->
  @if (items$ | async; as items) {
    @if (columns.length > 0) {
      <div class="flex flex-col max-h-400">
        <!-- Header -->
        <div
          class="flex flex-row gap-4 sticky top-0 px-6 py-4 text-md font-semibold text-secondary shadow bg-gray-50 dark:bg-black dark:bg-opacity-5 md:px-8">
          <!-- Column names -->
          @for (column of columns; track column) {
            <div class="flex-1">
              {{ column.dTypeColumn.caption | localize }}
            </div>
          }
        </div>
        <!-- Rows (iterator) -->
        @for (item of items; track item) {
          <div class="flex flex-row gap-4 items-center px-6 py-3 border-b md:px-8">
            <!-- Row data -->
            @for (column of columns; track column) {
              <div class="flex-1 truncate hover:text-clip hover:overflow-auto hover:whitespace-normal"
                [ngClass]="item[column.id] === null || item[column.id] === undefined ? 'text-disabled' : ''">
                {{ item[column.id] ?? "[null]" }}
              </div>
            }
          </div>
        }
      </div>
    } @else {
      <div class="p-8 border-t text-xl font-semibold tracking-tight text-center sm:p-16">
        {{ 'noColumns' | transloco }}
      </div>
    }
  }
</div>